import React, {Component} from 'react';
import * as func from "../../../../../utils/functions";
import MPIntroduceEdu from "./edu_module";
import MPIntroduceCarrer from "./carrer_module";

class MPIntroduce extends Component {
	constructor(props) {
		super(props);

		let eduData = this.props.record ? this.props.record.scholar_career.filter(f => f.career_type == "edu") : []
		let careerData = this.props.record ? this.props.record.scholar_career.filter(f => f.career_type == "carrer") : []

		this.state = {
			edu_data: eduData,
			career_data: careerData,
			field : 'my_library/intro'
		};
	}

	closePopup = () => {
		// this.props.onUpdate(this.state.record);
		this.props.closePopup('isShowEditIntroduce')
	}

	change = () => {
		const record = this.props.record;
		record[event.target.name] = event.target.value;
		this.props.onUpdate(record);
	}

	onSave = (event) => {
		event.preventDefault()
		// insert_scholar_intro
		func.updateData(this.state.field + '/update', this.props.record).then((response) => {
			if (response.code === 'ok') {
				this.setState({record : func.deepClone(this.props.record)})
				// this.props.showMessage('수정 되었습니다.');
				// this.props.closePopup('isShowEditProfile')
			} else {
				// this.props.showMessage('수정 실패 : ' + response.message)
			}
		});
	};

	render() {
		const record = this.props.record;

		if(!record.scholar_career)
			return '';

		return (
			<div className="modal show" id="careerModify" tabIndex="-1">
				<div className="modal-dialog modal-smd modal-dialog-centered">
					<div className="modal-content">
						<div className="modal-header pb-px-20">
							<h3 className="con-title">소개·학력·경력 수정</h3>
						</div>
						<div className="modal-body">
							<div className="font-size-14 color-lightblack">
								<div className="">소개</div>
								<div className="mt-px-10 pb-px-20">
									<textarea
										className="form-control" value={record.intro || ''}
										name="intro"
										ref={(ref) => this.intro = ref}
										onChange={this.change}
										placeholder="저자의 추가정보(소속, 학번, 메일 등)를 작성해 주세요."
									/>
									<button className="btn btn-outline-info btn-sm insert mr-1" style={{float: 'right',display: 'block',
										marginTop: '4px'}} onClick={this.onSave}>저장</button>
								</div>

								<MPIntroduceEdu career_data={this.state.edu_data} />

								<MPIntroduceCarrer career_data={this.state.career_data} />

							</div>
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-outline-gray" onClick={this.closePopup}>
								<strong>닫기</strong>
							</button>
						</div>
						<button type="button" className="btn-close" onClick={this.closePopup} />
					</div>
				</div>
			</div>
		)
	}
};

export default MPIntroduce;
